import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        minWidth: '300px',
        width: '85%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        maxWidth: '1000px',
        height: '80%',
        flexDirection: 'column'
    },
    overlay: {
        zIndex: 10000,
    }
}

const ModalComponent = ({ showModal, setShowModal, children, customStyle = {} }) => {

    Modal.setAppElement('#root')

    return (
        <Modal
            isOpen={showModal}
            onRequestClose={() => setShowModal(false)}
            style={{ ...customStyles, ...customStyle }}
            contentLabel="Example Modal">
            {children}
        </Modal>
    );
}

export default ModalComponent